module.exports = __webpack_public_path__ + "img/img6.64e453f5.jpg";